import Vue from 'vue'
import _ from 'lodash'
import bugsnag from '@/bugsnag'

function getInitialState () {
    return {
        favorites: []
    }
}

const state = getInitialState()

const mutations = {
    'INSERT_FAVORITES_LIST' (state, favorites) {
        state.favorites = _.union(state, favorites)
    },
    'REMOVE_FAVORITE' (state, {task, index = null}) {
        if (index !== null && index < state.favorites.length) {
            // Remove the task by index
            state.favorites.splice(index, 1)
        } else {
            // Find the correct index
            index = _.findIndex(state.favorites, task.id)

            // Remove the task by id from favorites
            state.favorites.splice(index, 1)
        }
    },
    'INSERT_FAVORITE' (state, task) {
        state.favorites = _.union(state.favorites, [task.id])
    },
    'RESET_FAVORITES' (state) {
        state = Object.assign(state, getInitialState())
    }
}

const actions = {
    favorites_list: ({commit, state}) => {
        Vue.http.get('favorites').then(response => {
            commit('INSERT_FAVORITES_LIST', response.body.data)
        }).catch(error => {
            bugsnag.notify(JSON.stringify(error))
        })
    },
    favorites_remove: ({commit, state}, task) => {
        Vue.http.delete('favorite/' + task.id).then(response => {
            commit('REMOVE_FAVORITE', {task})
        }).catch(error => {
            bugsnag.notify(JSON.stringify(error))
        })
    },
    favorites_clear: ({commit, state}) => {
        Vue.http.delete('favorites').then(response => {
            commit('RESET_FAVORITES')
        }).catch(error => {
            bugsnag.notify(JSON.stringify(error))
        })
    },
    favorites_insert: ({commit, state}, task) => {
        Vue.http.post('favorites', JSON.stringify({tasks: [task.id]})).then(response => {
            commit('INSERT_FAVORITE', task)
        }).catch(error => {
            bugsnag.notify(JSON.stringify(error))
        })
    }
}

const getters = {
    getFavorites: (state) => {
        return state.favorites
    },
    checkFavorited: (state, getters) => (task) => {
        return (_.findIndex(state.favorites, task.id) > -1)
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/favorites.js